/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingsharedhint3Inputs */

const en_profilebillingsharedhint3 = /** @type {(inputs: Profilebillingsharedhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A plan you pick below applies to this profile only.`)
};

const de_profilebillingsharedhint3 = /** @type {(inputs: Profilebillingsharedhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Plan, den du unten wählst, gilt nur für dieses Profil.`)
};

/**
* | output |
* | --- |
* | "A plan you pick below applies to this profile only." |
*
* @param {Profilebillingsharedhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingsharedhint3 = /** @type {((inputs?: Profilebillingsharedhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingsharedhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingsharedhint3(inputs)
	return de_profilebillingsharedhint3(inputs)
});
export { profilebillingsharedhint3 as "profileBillingSharedHint" }